import { Component, OnInit, ViewChild  } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { NavController, LoadingController, AlertController, PopoverController, ActionSheetController  } from '@ionic/angular';

import { Articulo } from '../../models/articulo';

import { StorageService } from '../../services/storage.service';
import { ArticulosService } from '../../services/articulos.service';
import { ActivatedRoute } from '@angular/router';
import { ModalArtComponent } from '../../components/modal-art/modal-art.component';
import { ArticulosComponent } from '../../components/articulos/articulos.component';
import { SidemenuAdminComponent } from '../../components/sidemenu-admin/sidemenu-admin.component';
import { HostListener } from "@angular/core";
import { DatosService } from '../../services/datos.service';
import { NuevoClienteComponent } from '../../components/nuevo-cliente/nuevo-cliente.component';


@Component({
  selector: 'myApp-seleccion-cliente',
  templateUrl: './seleccion-cliente.component.html',
  styleUrls: ['./seleccion-cliente.component.scss'],
})
export class SeleccionClienteComponent implements OnInit {

  @ViewChild(IonInfiniteScroll, {static: false}) infiniteScroll: IonInfiniteScroll;
  
  private subscriptions: Subscription[] = [];
  clientes = [];
  result:any[];
  view: any[];
  strCadena = '';
  strColumna = 'cl_nombre';
  count = 0;
  user: any;
  sede = '';
  screenHeight = 0;
  screenWidth = 0
  celular = false;
  constructor( private articuloServ: ArticulosService,
               private actionSheetCtrl: ActionSheetController,
               private nav: NavController,
               private alertController: AlertController,
               private modal: ModalController,
               private navCtrl: NavController,
               public datosService: DatosService,
               private loadingCtrl: LoadingController,
               private activatedRoute: ActivatedRoute,
               private storageServ: StorageService ) { }

  async ngOnInit() {
  
    
  }




  @HostListener('window:resize', ['$event'])
    onResize(event?) {
    if(window.innerWidth <= 700){
      console.log('Celular detectado');
      this.celular = true;
    }
    if(window.innerWidth >= 700){
      console.log('Web');
      this.celular = false;
    }
}

  async ionViewWillEnter(){

    const loading = await this.loadingCtrl.create({
      message: 'Cargando....',
      mode: 'ios'
    });
    await loading.present();
    this.cargarProductos();

    loading.dismiss();

  }

  async validarResolucion(){
    if(window.innerWidth <= 700){
      console.log('Celular detectado');
      this.celular = true;
    }
    if(window.innerWidth >= 700){
      console.log('Web');
      this.celular = false;
    }
  }


  async cargarProductos(){
    this.subscriptions.push(
      this.articuloServ.getClientes().subscribe(data =>{
        if(data){
          this.clientes = data;
          this.filtrar(null);
        }
        else{
          console.log('Sin productos');
        }
      })
    )
  }
  cerrar(){
    this.modal.dismiss();
  }


  async menu() {
    const modal = await this.modal.create({
      component: SidemenuAdminComponent,
      backdropDismiss: true,
      cssClass: 'menu-admin',
      componentProps: {
      
      
       sede: this.sede,
      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
     
    }
  }


  ionViewWillLeave() {
   
    this.subscriptions.forEach(item => {
 
      item.unsubscribe();
    });
 
  }

  ngOnDestroy() {
    this.subscriptions.forEach(item => {
    
      item.unsubscribe();
    });

  }



  

  filtrar( event ) {
    if(event){
      this.strCadena = event.detail.value;
    }
    

    if ( this.strCadena === '' ) {
      this.count = 0;
      this.result = this.clientes;
      this.loadData();
    } else {
      this.strCadena = this.strCadena.toLowerCase();

      this.result = this.clientes.filter( item => {
      return item[this.strColumna].toLowerCase()
              .includes( this.strCadena );
    });
      this.loadData();
    }
  }

  loadData( event? ) {
    this.count += 10;
    this.view = this.result.slice(0, this.count);
    this.infiniteScroll.disabled  = false;

    if ( event ) {
      event.target.complete();

      if ( this.view.length === this.result.length ) {
        event.target.disabled = true;
      } else {
        event.target.disabled = false;
      }
    }
  }

  doInfinite( event ) {
    this.loadData(event);
  }


 
seleccionar(c){
  this.modal.dismiss({
    cliente: c
  })
}



}
